import styled from 'styled-components'
import { cardisTheme } from '../../theme/cardisTheme'

export const DateContainer = styled.div`
  display: inline-flex;
  flex-direction: column;
`

export const Label = styled.label`
  font-family: ${cardisTheme.fonts.body};
  font-size: ${cardisTheme.fontSizes.small};
  font-weight: ${cardisTheme.fontWeights.medium};
  color: ${cardisTheme.colors.primary};
`

export const Input = styled.input`
  font-family: ${cardisTheme.fonts.body};
  font-size: ${cardisTheme.fontSizes.body};
  color: ${cardisTheme.colors.text};
  padding: 2px;
  border: 1px dashed #ffd700;
  border-radius: 4px;
  background: #fffef5;
  outline: none;
  min-width: 150px;

  &:hover {
    border-color: #ffd700;
    border-style: solid;
  }

  &:focus {
    border-color: #ffb700;
    border-style: solid;
    box-shadow: 0 0 0 2px rgba(255, 215, 0, 0.2);
  }

  @media print {
    border: none;
    background: transparent;
    padding: 0;
    min-width: auto;
  }
`

export const DisplayValue = styled.span`
  font-family: ${cardisTheme.fonts.body};
  font-size: ${cardisTheme.fontSizes.body};
  color: ${cardisTheme.colors.text};
  min-height: 24px;

  @media screen {
    display: none;
  }

  @media print {
    display: inline;
  }
`

export const EditableInput = styled(Input)`
  @media print {
    display: none;
  }
`
